<template lang="pug">
  .form-user
    .columns.is-multiline()
      .column.is-6-tablet.is-4-desktop
        b-switch(v-model="value.status" :true-value="1" :false-value="0" :disabled="isSelfEdit") Активная учетная запись


    .columns.is-multiline
      .column.is-6-tablet.is-4-desktop
        ui-field(label="Фамилия" v-model="value.last_name" :error="errors.last_name" rules="required")

      .column.is-6-tablet.is-4-desktop
        ui-field(label="Имя" v-model="value.first_name" :error="errors.first_name" rules="required")

      .column.is-6-tablet.is-4-desktop
        ui-field(label="Отчество" v-model="value.patronymic" :error="errors.patronymic")

      .column.is-6-tablet.is-4-desktop
        ui-field(label="E-mail" v-model="value.email" :error="errors.email" rules="required|email")

      .column.is-6-tablet.is-4-desktop
        ui-field(label="Телефон" v-model="value.phone" :error="errors.phone")

    //- Пароль
    .columns.is-multiline(v-if="!value.$state.loading")
      .column.is-6-tablet.is-4-desktop
        b-switch(v-if="!value.$isNew" v-model="changePassword") Изменить пароль
        template(v-if="changePassword || value.$isNew")
          ui-field(label="Пароль" type="password" v-model="value.password" :error="errors.password" rules="required|min:6")

    //- Группа пользователя
    .columns.is-multiline(v-if="user.isAdmin")
      .column.is-6-tablet.is-4-desktop()
        ui-field(label="Группа пользователей" type="select" v-model="value.group_id" :error="errors.group_id" rules="required" :disabled="isSelfEdit")
          option(v-for="group in userGroups.items" :value="group.id" :key="group.id") {{ group.title }}


</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'form-user',

  props: {
    value: null,
    errors: Object,
  },

  data: () => ({
    changePassword: false,
  }),

  computed: {
    saving() {
      return this.value && this.value.$state.saving;
    },

    ...mapGetters(['userGroups', 'user']),

    isSelfEdit() {
      return this.value.id === this.user.id;
    },
  },

  watch: {
    saving(newState, oldState) {
      this.changePassword = false;

      // После сохранения
      if (oldState && !newState) {
        // Если изменил свои данные, обновляем стор (текущего пользователя)
        if (this.isSelfEdit) {
          this.$store.commit('setUser', this.value.$getData());
        }
      }
    },
  },
};
</script>
